import React, { useContext, useState } from "react";
import "./loginForm.css";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import ValidationError from "../validationError";
import { baseRequest } from "../../axiosconfig";
import { Link, useNavigate } from "react-router-dom";
import Loading from "../loading";
import { UserContext } from "../../userContext";

export default function LoginForm({ setIsloggedin }) {
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState(null);

  const { setUser } = useContext(UserContext);

  const navigate = useNavigate();

  const handleShowPassword = () => {
    setShowPassword((prevState) => {
      return !prevState;
    });
  };

  return (
    <div className="login-form-wrapper">
      <Formik
        initialValues={{
          password: "",
          email: "",
        }}
        validateOnChange={false}
        validateOnBlur={false}
        validationSchema={Yup.object({
          email: Yup.string().email("Unesite ispravnu imejl adresu").required("Imejl je obavezan"),
          password: Yup.string().required("Lozinka je obavezna"),
        })}
        onSubmit={async (values, { setFieldError }) => {
          setLoading(true);
          baseRequest
            .post("/login", {
              password: values.password,
              email: values.email,
            })
            .then((res) => {
              baseRequest.get("/user").then((res) => {
                setUser(res.data.data);
                setIsloggedin(true);
                setLoading(false);
                navigate("/admin/struktura-preduzeca");
              }).catch(() => {
                setLoading(false);
              });
            })
            .catch((error) => {
              setLoading(false);
              const errors = error.response?.data?.errors;
              if (errors) {
                Object.keys(errors).forEach((error) => {
                  setFieldError(error, errors[error]);
                });
              }
            });
        }}
      >
        {({ errors, touched }) => (
          <Form className="login-form">
            <div className="login-form-field-wrapper">
              <label htmlFor="email" className="login-form-field-label">
                Imejl-adresa:*
              </label>
              <Field name="email" type="text" className="login-textfield" />
              {errors.email && <ValidationError error={errors.email} />}
            </div>
            <div
              className="login-form-field-wrapper"
              style={{ marginBottom: "10px" }}
            >
              <label htmlFor="password" className="login-form-field-label">
                Vaša lozinka:*
              </label>
              <Field
                name="password"
                type={showPassword ? "text" : "password"}
                className="login-textfield"
              />
              <button
                className="show-password-button"
                type="button"
                onClick={handleShowPassword}
              >
                <img src="/images/showpassword.png" />
                {showPassword && <span className="slash"></span>}
              </button>
              {errors.password && <ValidationError error={errors.password} />}
            </div>
            <div
              className="login-form-link-wrapper"
              style={{ marginBottom: "20px" }}
            >
              <Link to="/forgotten-password" className="login-form-link">
                Zaboravljena lozinka / Obnova lozinke
              </Link>
            </div>
            <button type="submit" className="login-form-button">
              Prijavite se
            </button>
          </Form>
        )}
      </Formik>

      <Loading isLoading={loading} />
    </div>
  );
}
